const COLORS = {
  white: '#ffffff',
  darkPurple: '#1D1A31',
  dimViolet: '#B8ABBA',
  plum: '#9A4C95',
  englishVioletAlt: '#5D3E65',
  darkerGray: '#717171',
  lighterGray: '#BAC0CA',
  cyan: '#45FFFF',
};

const STRING_CONSTANTS = {
  SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN: 'Something went wrong. Please try again',
  IMAGE_UPLOADER_ERROR_TOO_MANY_FILES: 'You can only upload one file',
  IMAGE_UPLOADER_ERROR_INCORRECT_FORMAT: 'Incorrect file format',
  VIDEO_FILE_TOO_LONG: (minutes: number) => `Video is too long.\nMaximum allowed video duration is ${Math.ceil(minutes)} minute${Math.ceil(minutes) > 1 ? 's' : ''}.`,
  VIDEO_FILE_INCORRECT_FORMAT: 'This video file could not be read by your browser\nTo continue, please choose another video file.',
};

const MB_RESOURCE_PICKER_CONSTANTS = {
  MAX_IMAGE_SIZE_AFTER_COMPRESSION: 3 * 1024 * 1024,
  MAX_VIDEO_SIZE: 500 * 1024 * 1024,
  MAX_FILE_SIZE: 16 * 1024 * 1024,
};

export { COLORS, STRING_CONSTANTS, MB_RESOURCE_PICKER_CONSTANTS };
